import { Component } from '@angular/core';
import { repairTasksVisible } from '@/utils/repair-task-visibility';

@Component({
  standalone: false,
  selector: 'wr-user-dashboard-page',
  templateUrl: './user-dashboard-page.component.html',
  styleUrls: ['./user-dashboard-page.component.scss'],
})
export class UserDashboardPageComponent {
  readonly repairTasksVisible = repairTasksVisible();
}
